<template>
  <router-link :to="link">
    <div class="underline">
      {{ title }}
    </div>
  </router-link>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  link: string;
}>();
</script>
